import { createSelector, createStructuredSelector } from 'reselect';
import { createConfigSelector } from '@americanexpress/travel-selectors';
import { locales } from '@americanexpress/conditional-features';
import { AXP_CLIENT_TEALEAF_URL_US, AXP_CLIENT_TEALEAF_URL_INTL } from '../constants/environmentVariableConstants';
import getActiveLocaleFromUrl from '../utils/getActiveLocaleFromUrlUtil';

export const getTealeafUrls = createStructuredSelector({
  usTealeafUrl: createConfigSelector(AXP_CLIENT_TEALEAF_URL_US),
  intlTealeafUrl: createConfigSelector(AXP_CLIENT_TEALEAF_URL_INTL),
});

export const getHasTealeafEnabledForIntl = (_, hasTealeafIntl) => hasTealeafIntl;

const getTealeafDetails = createSelector(
  getHasTealeafEnabledForIntl,
  getTealeafUrls,
  (hasTealeafIntl, tealeafUrls) => {
    const activeLocale = getActiveLocaleFromUrl();
    const tealeaf = { src: '' };
    if (activeLocale) {
      if (activeLocale === locales.EN_US) {
        tealeaf.src = tealeafUrls.usTealeafUrl;
      } else if (hasTealeafIntl) {
        tealeaf.src = tealeafUrls.intlTealeafUrl;
      }
    }
    return tealeaf;
  }
);

export default getTealeafDetails;
